import React, { memo, useCallback, useContext } from 'react'
import { BasicDateRangePicker } from 'src/components/shared/form/BasicDateRangePicker'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'

const ContractorDateOnboardedSelectComponent = () => {
  const { dateOnboardedRange, setDateOnboardedRange } = useContext(ContractorsTableContext)

  const handleClear = useCallback(() => {
    setDateOnboardedRange([null, null])
  }, [setDateOnboardedRange])

  return (
    <BasicDateRangePicker
      title="Date onboarded"
      value={dateOnboardedRange}
      onChange={setDateOnboardedRange}
      onClear={handleClear}
    />
  )
}

export const ContractorDateOnboardedSelect = memo(ContractorDateOnboardedSelectComponent)
